var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap",
    },
    [
      !_vm.noOption
        ? _c("div", [
            _c(
              "select",
              {
                staticClass: "boss-input-select",
                domProps: { value: _vm.getSelectedOptionData.terms },
                on: { change: _vm.onSelectedChange },
              },
              _vm._l(_vm.options, function (option, i) {
                return _c(
                  "option",
                  {
                    key: i,
                    attrs: { "data-test": "select-option-" + option.terms },
                    domProps: { value: option.terms },
                  },
                  [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("date-picker", {
            attrs: {
              value: [_vm.from, _vm.to],
              disabled: _vm.isDisabled,
              shortcuts: _vm.shortcuts,
              type: "date",
              format: "YYYY-MM-DD",
              "disabled-date": _vm.notAfterToday,
              "default-value": _vm.defaultDate,
              "input-class": "pega-picker",
              "value-type": "format",
              editable: false,
              range: "",
              placeholder: "期間を選択",
            },
            on: { input: _vm.onUpdateTerm },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.notice
        ? _c(
            "span",
            {
              staticClass: "boss-annotation-text",
              attrs: { "data-test": "notice" },
            },
            [_vm._v("\n    " + _vm._s(_vm.notice) + "\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }